import type { ExternalMediaSensitivityMetadata } from "./ExternalMediaTypes";

export function buildExternalMediaSensitivityMetadata(input: {
    providersPresent: Iterable<string>;
    adultProvidersPresent: Iterable<string>;
}): ExternalMediaSensitivityMetadata {
    const providersPresent = Array.from(new Set(input.providersPresent)).sort();
    const adultProvidersPresent = Array.from(new Set(input.adultProvidersPresent)).sort();
    const containsAdultMedia = adultProvidersPresent.length > 0;

    return {
        containsExternalMedia: providersPresent.length > 0,
        containsAdultMedia,
        providersPresent,
        adultProvidersPresent,
        sensitivityRecommendation: containsAdultMedia ? "AUTO_SENSITIVE" : "NONE",
        sensitiveReasonCodes: containsAdultMedia ? ["ADULT_EXTERNAL_MEDIA_PRESENT"] : [],
    };
}
